import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-port-page',
  templateUrl: './port-page.component.html',
  styleUrls: ['./port-page.component.scss']
})
export class PortPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
